export default "__VITE_ASSET__f9be9644__"